import React from 'react';
import { useDispatch } from 'react-redux';
import { setServiceType, openServiceDialog } from '../../store/serviceBookingSlice';
import priestImage from '../../assets/images/quickservices/priest.png';
import tentImage from '../../assets/images/quickservices/tent.png';
import cateringImage from '../../assets/images/quickservices/catering.png';
import venueImage from '../../assets/images/quickservices/venue.png';
import './ServiceButtons.css';
import config from '../../config';

const ServiceButtons = ({
  showPriest = config.isIndia,
  showCatering = true,
  showTent = true,
  showVenue = true,
  isLoggedIn = false,
  showAlways = false,
  hideForLoggedIn = false,
  showOrSeparator = true,
  onServiceSelect,
  eventDetails = null, // ADD THIS PROP
  formik = null, // ADD THIS PROP
  children
}) => {
  const dispatch = useDispatch();

  const handleServiceButtonClick = (serviceType) => {
    console.log("Selected service type:", serviceType);



    // For other services, use the existing logic
    if (onServiceSelect) {
      onServiceSelect(serviceType);
      return;
    }

    dispatch(setServiceType(serviceType));
    dispatch(openServiceDialog());
  };

  // Hide logic
  if (!showAlways && hideForLoggedIn && isLoggedIn) {
    return null;
  }

  return (
    <>
      <div className="provider-services2">
        {showPriest && (
          <div
            className="servicesinfo"
            onClick={() => handleServiceButtonClick('priest')}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && handleServiceButtonClick('priest')}
          >
            <div className="servicetext">
              <span className="title">Book Priest</span>
              <span className="subtitle">Qualified and experienced priests for all rituals</span>
            </div>
            <img src={priestImage} alt="priest" className="serviceImage" />
          </div>
        )}

        {showCatering && (
          <div
            className="servicesinfo"
            onClick={() => handleServiceButtonClick('catering')}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && handleServiceButtonClick('catering')}
          >
            <div className="servicetext">
              <span className="title">Order Catering</span>
              <span className="subtitle">Choose caterers that can serve your customized menu</span>
            </div>
            <img src={cateringImage} alt="catering" className="serviceImage" />
          </div>
        )}

        {showTent && (
          <div
            className="servicesinfo"
            onClick={() => handleServiceButtonClick('tent')}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && handleServiceButtonClick('tent')}
          >
            <div className="servicetext">
              <span className="title">Tent House</span>
              <span className="subtitle">Tents, chairs, tables, decorations and more</span>
            </div>
            <img src={tentImage} alt="tent" className="serviceImage" />
          </div>
        )}

        {showVenue && (
          <div
            className="servicesinfo"
            onClick={() => handleServiceButtonClick('venue')}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && handleServiceButtonClick('venue')}
          >
            <div className="servicetext">
              <span className="title">Book Venue</span>
              <span className="subtitle">Indoors, Outdoors, Rooftop, Farmhouse and more</span>
            </div>
            <img src={venueImage} alt="venue" className="serviceImage" />
          </div>
        )}

        {children}
      </div>

      {/* Conditionally show the "Or" separator */}
      {showOrSeparator && !isLoggedIn && <span className="th-or-divider">OR</span>}
    </>
  );
};

export default ServiceButtons;